import Cookies from 'js-cookie';
import { constructUrlWithParams } from '@groma-dev/scaffold';
import { AppConfig } from '../../core/AppConfig';
import { AppRoutes, authenticatedRoutes } from '../../core/routes';
import { ImageAspectRatio } from './Constants';

export const parseLocationSearch = (search: string): any => {
  const result: any = {};

  if (search.length === 0) return result;

  const args = search.substring(1).split('&');
  let i;
  let arg;
  let kvp;
  let key;
  let value;

  for (i = 0; i < args.length; i++) {
    arg = args[i];

    if (arg.indexOf('=') === -1) {
      result[decodeURIComponent(arg).trim()] = true;
    } else {
      kvp = arg.split('=');

      key = decodeURIComponent(kvp[0]).trim();
      value = decodeURIComponent(kvp[1]).trim();

      result[key] = value;
    }
  }

  return result;
};

export const constructLocationSearch = (params: { [key: string]: string }): string => {
  const searchParams = Object.keys(params)
    .map((key: string) => {
      if (params[key]) return `${key}=${encodeURIComponent(params[key])}`;
      else return false;
    })
    .filter(Boolean);

  return searchParams.length > 0 ? `?${searchParams.join('&')}` : '';
};

export const authCookiePresent = () => {
  const { name: cookieName } = AppConfig.Settings.Authentication.cookie;
  return Cookies.get(cookieName);
};

export const isValidEmail = (email: string) => {
  const emailRegex = /^\S+@\S+\.\S+$/;
  const regex = new RegExp(emailRegex);

  return regex.test(email);
};

/**
 * Check if route is an unauthenticated route.
 * Usage is to determine if redirects need to happened based on a page trying to be loaded that
 */
export const isAuthenticatedRoute = (route: string) => {
  return Object.values(authenticatedRoutes).includes(route);
};

/**
 * Check if route is a registered AppRoute.
 * Usage is to determine if redirects need to happened based on authenticated or unauthenticated requests
 */
export const isAppRoute = (route: string) => {
  return Object.values(AppRoutes).includes(route);
};

export const scrollToTop = () => {
  // eslint-disable-next-line no-multi-assign
  document.body.scrollTop = document.documentElement.scrollTop = 0;
};

export const getBaseGromaUrl = () => {
  const baseUrl = window.location.host;

  if (baseUrl?.includes('sandbox')) return 'https://sandbox.groma.com';
  else if (baseUrl?.includes('preprod')) return 'https://preprod.groma.com';
  else return 'https://groma.com';
};

export const jumpToAnchorRef = () => {
  let counter = 0;

  const interval = setInterval(() => {
    if (counter === 10) clearInterval(interval);

    findElement();
    counter++;
  }, 500);

  const findElement = () => {
    const { hash } = window.location;
    const el = document.getElementById(hash?.split('#')[1]);

    if (el) {
      if (interval) clearInterval(interval);
      el.scrollIntoView(true);
    }
  };

  findElement();
};

export const buildUrlWithParams = (url: string) => {
  const { allowList } = AppConfig.Settings.Routing.searchParams;
  return constructUrlWithParams(url, { persistList: allowList });
};

export const buildImageUrl = (url: string, ratio?: ImageAspectRatio) => {
  return `${url}${ratio ? `?crop=${ratio}` : ''}`;
};
